import React, {useEffect} from 'react'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function Banner() {
    useEffect(() => {
        Fancybox.bind('[data-fancybox="single"]', {
            groupAttr: false,
        });

        return () => {
            Fancybox.destroy();
        };
    }, []);
  return (
    <section className="home banner" id="fifty-banner">
        <div className="row ">
            <div className="container">
                <div className="banne-wrap wow zoomIn">
                    <div className="banner-text">
                        <h1>Snapshot Videos: <span className="red">Your Monthly Member Update, Reimagined.</span>
                        </h1>
                        <a href="#reserve-your-spot" className="btn order-btn">Order Now</a>
                        <div className="banner-image">
                            <a data-fancybox="single" href="/images/firstFifty-images/Snapshot-Videos-First-50-Header.mp4" className="popup popup-btn">
                                {/* <!-- <video controls>
                                <source src="images/video-1.mp4" type="video/mp4">
                                </video> -->
                                <!-- <img src="./images/banner-right-image.jpg" alt="banner right image"> --> */}
                            </a>
                            <img src="/images/firstFifty-images/1st-50-latest.png" alt="banner right image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Banner